import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { ProductionStatement } from "@/models/production-statement.model"

export const useProductionStatementStore = defineStore("productionStatementsStore", () => {
  const productionStatements: Ref<ProductionStatement[]> = ref([])

  return {
    productionStatements
  }
})
